export default __webpack_public_path__ + "static/media/Human.8e3b8e98.mp4";